/** Minimum characters before destination autocomplete requests fire (UI + API). */
export const DESTINATION_MIN_QUERY_LENGTH = 3;

/** Debounce delay for destination autocomplete input (ms). */
export const DESTINATION_SEARCH_DEBOUNCE_MS = 300;
